<!--If component data exists-->
@if (tilesComponentData$ | async; as data) {
  <div
    class="container-fluid tiles-container-wrapper {{ data.styleClasses ? data.styleClasses : ''}}"
    [style.--tile-container-background-color]="data.backgroundColor ?? 'inherit'"
    [style.--tiles-container-text-color]="data.color ?? 'inherit'"
    [ngClass]="{'addMoreSpace' : ((isHelpPage | async) || (isHelpAnonymousPage | async)) }"
    >
    @if (data.active === 'false') {
      <div class="inactiveContainer">
        <div class="image-box">
          <img src="icons/Maintenance.png" alt="">
        </div>
        <div class="inactiv-item-text-wrapper">
          @if ((data.inActiveTitle | json) != '{}') {
            <div
            class="text-title">{{ data.inActiveTitle }}</div>
          }
          @if ((data.inActiveText | json) != '{}') {
            <div
            class="text-description">{{data.inActiveText}}</div>
          }
        </div>
      </div>
    }
    <!--if tile item exists-->
    @if (tileItems) {
      <div
        [ngStyle]="{'filter':(data.active === 'false') ? 'opacity(30%) blur(24px)' : 'none' }"
        >
        <div class="tiles-container" #tilesContainer
          [ngStyle]="{'margin-bottom': (isTiresAndMorePage | async) ? '0px' : '50px'}"
          >
          <!--Tiles title-->
          <div class="col-xs-12">
            <h2 [ngClass]="data.titleLeftAligned === 'true' ? 'title-left-aligned': ''">
              <span>{{ data.title }}</span>
            </h2>
          </div>
          <div class="row">
            @if (!(isDownloadCustomerInfoPage|async)) {
              <div
                class="d-flex align-center col-md-1 justify-content-center"
                [ngClass]="{ 'col-2' : data.numberOfTilesPerRow < tileItems.length }">
                @if (data.numberOfTilesPerRow < tileItems.length) {
                  <button type="button" class="previous" [disabled]="tilesVisibleLowIndex === 0"
                    (click)="slideLeft()">
                    <cx-icon [type]="iconType.CARET_LEFT" class="tiles-container-slide-icon"></cx-icon>
                  </button>
                }
              </div>
            }
            <div class="{{colConfig}}"
              [ngClass]="{'col-8':  data.numberOfTilesPerRow < tileItems.length}">
              <div class="row">
                <!--show all the tile items-->
                @if (
                  isShowMore ||
                  !data.enableShowMore ||
                  (tileItems.length <= data.numberOfTilesPerRow && data.numberOfTilesPerRow < 5)) {
                  <!--tile items loop-->
                  @for (item of tileItems; track item) {
                    <div
                  class="d-flex col-12 col-sm-6 col-lg-{{
                    12 / data.numberOfTilesPerRow
                  }}"
                      >
                      <!--tile item-->
                      @if (
                        item.typeCode === 'PneuConfiguratorComponent') {
                        <app-efa-pneu-configurator
                          [tileItem]="item"
                        ></app-efa-pneu-configurator>
                      } @else {
                        @if (item.typeCode === 'TysysCatalogComponent') {
                          <app-efa-tysys-catalog [tileItem]="item"></app-efa-tysys-catalog>
                        } @else {
                          <app-efa-tile-cms-item
                            [tileItem]="item"
                          ></app-efa-tile-cms-item>
                        }
                      }
                    </div>
                  }
                } @else {
                  <!--tile items loop-->
                  @for (item of tileItems; track item; let i = $index) {
                    @if (i <= tilesVisibleHighIndex && i >= tilesVisibleLowIndex) {
                      <div
                  class="col-xs-12 col-sm-6 col-md-6 col-lg-{{
                    12 / data.numberOfTilesPerRow
                  }}"
                        >
                        <!--tile item-->
                        @if (
                          item.typeCode === 'PneuConfiguratorComponent') {
                          <app-efa-pneu-configurator
                            [tileItem]="item"
                          ></app-efa-pneu-configurator>
                        } @else {
                          @if (item.typeCode === 'TysysCatalogComponent') {
                            <app-efa-tysys-catalog [tileItem]="item"></app-efa-tysys-catalog>
                          } @else {
                            <app-efa-tile-cms-item
                              [tileItem]="item"
                            ></app-efa-tile-cms-item>
                          }
                        }
                      </div>
                    }
                  }
                }
                <!--show less tile items-->
              </div>
            </div>
            @if (!(isDownloadCustomerInfoPage|async)) {
              <div
                class="d-flex align-center col-md-1 justify-content-center"
                [ngClass]="{ 'col-2' : data.numberOfTilesPerRow < tileItems.length }">
                @if (data.numberOfTilesPerRow < tileItems.length) {
                  <button type="button"
                    [disabled]="tilesVisibleHighIndex >= (tileItems.length - 1)" class="next"
                    (click)="slideRight(tileItems.length)">
                    <cx-icon [type]="iconType.CARET_RIGHT" class="tiles-container-slide-icon"></cx-icon>
                  </button>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }
    @if (data.displayBottomLine === 'true') {
      <hr>
      }
    </div>
  }
